




























































































































































import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Cconstruction extends Vue {
  bottomText = [
    {
      title1: "快速部署归档",
      body: "录入与导出实验手册，记录学习数据，调用计算环境"
    },
    {
      title1: "打破时空限制",
      body:
        "一个平台可进行多种技术实验，课程与实验设计符合院校教学逻辑，轻松管理课程资源与实验资源。"
    },
    {
      title1: "随时动手练习",
      body: "支持虚拟化/容器技术，利用现有设备及云资源，打造在线实验环境"
    },
    {
      title1: "平台设计聚焦客户体验",
      body: "根据客户需求设定客户行为库，根据客户需求驱动平台设计。"
    },
    {
      title1: "支持多人协同、桌面分享",
      body: "支持B/S架构，真正实现“任何人、任何时间、任何地点”开展实验"
    },
    {
      title1: "智能配备资源",
      body: "根据客户对时间、价格的要求按需搭配组合资源配比。"
    }
  ];
  picList = [
    {
      title: "OpenEuler",
      //text1: "硬件资源虚拟化",
      //text3: "轻量级运营，可视化管理",
      text2:
        " openEuler是一个开源免费的Linux发行版系统，通过开放的社区形式与全球的开发者共同构建一个开放、多元和架构包容的软件生态体系，openEuler同时是一个创新的系统，倡导客户在系统上提出创新想法、开拓新思路、实践新方案。",
      img: require("@/zh-website/src/assets/Cloud_4.png")
    },
    {
      title: "OpenGauss",
      //text1: "云端一键部署",
      //text3: "用户随地接入，平台统一管理",
      text2:
        "openGauss是一款开源关系型数据库管理系统，采用木兰宽松许可证v2发行。openGauss内核源自PostgreSQL，深度融合华为在数据库领域多年的经验，结合企业级场景需求，持续构建竞争力特性。",
      img: require("@/zh-website/src/assets/Cloud_5.png")
    },
    {
      title: "华为鲲鹏云服务",
      //text1: "一云两冀双引擎",
      //text3: "灵活部署环境，满足多元需求",
      text2:
        " 华为鲲鹏云服务开启多元计算新架构，加速企业创新升级。具有提供多核算力、高性价比、端云协同、生态丰等多重优势，可为企业提供计算、存储、网络、容器服务、管理工具等众多通用基础与专项高阶服务。",
      img: require("@/zh-website/src/assets/Cloud_6.png")
    },
    {
      title: "BigData Pro大数据解决方案",
      //text1: "云端一键部署",
      //text3: "用户随地接入，平台统一管理",
      text2:
        "结合华为云丰富的大数据平台和基础云服务经验，为企业提供高性能、高可靠的大数据业务基础资源、AI训练推理平台，快速实现企业数据化、智能化转型。",
      img: require("@/zh-website/src/assets/Cloud_5.png")
    }
  ];
}
